import { Modal } from 'reactstrap';
import { useState, useEffect, useContext } from 'react';
import { Context as AuthContext } from '../../contexts/AuthContext';
import UserService from '../../services/User';
import { createPagedMeta } from '../../entities/PagedMeta';
import { createOptionsPage } from '../../entities/OptionsPaged';
import Pagination from '../Core/Pagination';
import BaseNavBarNotificationItem from './BaseNavBarNotificationItem';

const BaseNavbarNotificationModal = ({ isOpen, toggle }: { isOpen: boolean; toggle: () => void }) => {
  const { token, currentSchool, user }: any = useContext(AuthContext);
  const [filteredOptions, setFilteredOptions] = useState({
    filters: [
      { field: 'userId', value: user?.id, operation: 'hash' },
      { field: 'deletedAt', operation: 'is_null' },
      { field: 'schoolId', value: currentSchool?.value, operation: 'hash' },
    ],
    options: createOptionsPage(createPagedMeta(), { sortBy: 'createdAt', sortDesc: 'desc' }),
  });
  const [data, setData] = useState<{ data: any[]; meta: any }>({ data: [], meta: {} });

  const handlePageChange = async (page: number) => {
    const newOptions = {
      ...createPagedMeta(),
      currentPage: page,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions, { sortDesc: 'desc' }),
    };
    console.log(newFilteredOptions);
    setFilteredOptions(newFilteredOptions);
  };

  useEffect(() => {
    const loadNotifications = async () => {
      const response = await UserService(token).notifications(currentSchool.value, filteredOptions);
      setData(response);
    };
    loadNotifications();
  }, [filteredOptions]);
  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen} toggle={toggle} size={'lg'}>
      <div className="modal-header">
        <h4 className="modal-title">My Notifications</h4>
        <div onClick={toggle} className="d-flex p-1 cursor-pointer">
          <i className="fas fa-times" />
        </div>
      </div>
      <div className="modal-body">
        {data?.data?.map((item: any) => {
          return (
            <BaseNavBarNotificationItem
              key={`notification-list-${item?.id}`}
              item={item}
              insideDropdown={false}
              onOpen={toggle}
            />
          );
        })}
        <Pagination
          data={data?.data}
          meta={data?.meta}
          onChangeRowsPerPage={async (perPage: any) => console.log(perPage)}
          onChangePage={handlePageChange}
        />
      </div>
    </Modal>
  );
};
export default BaseNavbarNotificationModal;
